<div class="dashboardWidget medium" #dashboardNewsWidget>
  <a href="inspire" style="text-decoration: none" (click)="setRoute($event)">
    <div class="dashboardWrapper newsWidget">
      <div class="newsWidgetWrapper">

        <div *ngIf="(systemSettings$ | async) as systemSettings">

          <div class="oneNumberWidget text-center" style="width: 100%; height: 200px; vertical-align: middle;">
            <!--div class="inner big-numbers"-->
            <div style="text-align:center; padding-top: 20px; height: 150px">
              <!--fa-icon icon="newspaper"></fa-icon-->
              <div id="crossfade" *ngIf="systemSettings.inspireNotificationActive">
                <img class="bottom" src="/img/dashboard/inspire_off.png" height="100%">
                <img class="top" src="/img/dashboard/inspire_on.png" height="100%">
              </div>

              <div id="no-crossfade" *ngIf="!systemSettings.inspireNotificationActive">
                <img class="bottom" src="/img/dashboard/inspire_off.png" height="100%">
              </div>
            </div>
            <div class="widgetScrollText" *ngIf="systemSettings.inspireNotificationActive">
              <ng-marquee #ngMarquee duration="25" >
                <mark class="scrollingTextMark">{{systemSettings.inspireNotificationText}} </mark>
              </ng-marquee>
            </div>
          </div>

        </div>
      </div>
    </div>
  </a>
</div>
